import React, { useState } from "react";
import { TextField, Typography } from "@mui/material";

const EmailField = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  errors,
  errorKey,
}) => {
  const [formatError, setFormatError] = useState(false);

  const hasRequiredError = errors?.includes(errorKey || name);

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleChange = (e) => {
    const val = e.target.value;
    if (val && !isValidEmail(val)) {
      setFormatError(true);
    } else {
      setFormatError(false);
    }
    onChange(e);
  };

  return (
    <>
      <Typography className="color-blue-dark title-input">{label}</Typography>
      <div style={{ position: "relative" }}>
        <TextField
          name={name}
          value={value || ""}
          placeholder={placeholder}
          fullWidth
          variant="outlined"
          error={hasRequiredError || formatError}
          helperText={formatError ? "Formato email non valido" : undefined}
          FormHelperTextProps={{
            sx: { marginLeft: "2px", position: "absolute", bottom: "-20px" },
          }}
          onChange={handleChange}
        />
      </div>
    </>
  );
};

export default EmailField;
